import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../api/methodsCfg";

// ─── Variant Group CRUD ──────────────────────────────────────────────────────

export const getVariantGroupsByRestaurant = async (restaurantId) => {
  const response = await getRequest(
    `/dishvariantgroup/restaurant/${restaurantId}`,
  );
  return response;
};

export const getVariantGroupById = async (groupId) => {
  const response = await getRequest(`/dishvariantgroup/${groupId}`);
  return response;
};

export const createVariantGroup = async (payload) => {
  const response = await postRequest("/dishvariantgroup", payload);
  return response;
};

export const updateVariantGroup = async (groupId, payload) => {
  const response = await putRequest(`/dishvariantgroup/${groupId}`, payload);
  return response;
};

export const updateVariantGroupsOrder = async (restaurantId, ids) => {
  const response = await putRequest(
    `/dishvariantgroup/order/${restaurantId}`,
    { ids },
  );
  return response;
};

export const deleteVariantGroup = async (groupId) => {
  const response = await deleteRequest(`/dishvariantgroup/${groupId}`);
  return response;
};

// ─── Individual Variant CRUD ─────────────────────────────────────────────────

export const addVariantToGroup = async (groupId, payload) => {
  const response = await postRequest(
    `/dishvariantgroup/${groupId}/variant`,
    payload,
  );
  return response;
};

export const updateVariant = async (variantId, payload) => {
  const response = await putRequest(
    `/dishvariantgroup/variant/${variantId}`,
    payload,
  );
  return response;
};

export const updateVariantsOrder = async (groupId, ids) => {
  const response = await putRequest(
    `/dishvariantgroup/${groupId}/variant/order`,
    { ids },
  );
  return response;
};

export const deleteVariant = async (variantId) => {
  const response = await deleteRequest(
    `/dishvariantgroup/variant/${variantId}`,
  );
  return response;
};

// ─── Dish Assignment ─────────────────────────────────────────────────────────

export const assignDishToGroup = async (groupId, dishId) => {
  const response = await putRequest(
    `/dishvariantgroup/${groupId}/dish/${dishId}`,
  );
  return response;
};

export const removeDishFromGroup = async (groupId, dishId) => {
  const response = await deleteRequest(
    `/dishvariantgroup/${groupId}/dish/${dishId}`,
  );
  return response;
};

export const getDishesByGroup = async (groupId) => {
  const response = await getRequest(`/dishvariantgroup/${groupId}/dishes`);
  return response;
};
